import axios from "axios";
import { Message, Loading } from "element-ui";
// import { getToken} from './auth'
// http://zhhb.azureflying.com:8201 //正式环境
// `http://192.168.199.165`;        // bin
// `http://116.62.114.125:8201/`     //测试环境
// `http://wxb.vaiwan.com`;         // 标`
// `http://192.168.199.180:8201`
export const setting = {
  baseUrl: "https://www.azureflying.com/api"
  // baseUrl: 'http://wxb.vaiwan.com'
  // baseUrl: 'http://116.62.114.125:8201/'
};

// 创建axios实例
const service = axios.create({
  baseURL: setting.baseUrl,
  timeout: 240000 // request timeout
});

// 请求拦截器，用于生产配置，记录日志等等
service.interceptors.request.use(
  config => {
    config.headers = Object.assign(
      {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        // 'Authorization': getToken() || '' // 请求头中注入token，如果不需要可以删除
      },
      config.headers
    );

    // axios的get和post请求传参方式不一样，所以这里需要适配
    const paramName =
      config.method.toLocaleLowerCase() === "get" ? "params" : "data";
    config[paramName] = config.data;

    // 这种数据格式需要转换一下才能正确传输
    if (
      config.headers["Content-Type"] ===
      "application/x-www-form-urlencoded;charset=utf-8"
    ) {
      config.transformRequest = [
        function(data) {
          let ret = "";

          for (let it in data) {
            ret +=
              encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }

          return ret.substring(0, ret.length - 1);
        }
      ];
    }

    if (config.showLoading) {
      showFullScreenLoading();
    }

    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// 响应拦截器，用于用户交互，记录日志等等
service.interceptors.response.use(
  response => {
    if (response.config.showLoading) {
      tryHideFullScreenLoading();
    }

    if (response.status === 200) {
      response.data.success = response.data.result === "1";
      return response.data;
    } else {
      showErrorMessage();

      return Promise.reject(response);
    }
  },
  error => {
    tryHideFullScreenLoading();
    showErrorMessage();

    return Promise.reject(error);
  }
);

let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中",
    background: "rgba(0, 0, 0, 0.7)"
  });
}

function endLoading() {
  loading.close();
}

function showErrorMessage(message = "请求异常,请重试") {
  Message({
    message,
    type: "error",
    duration: 5 * 1000
  });
}

let needLoadingRequestCount = 0;
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }

  needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;

  needLoadingRequestCount--;

  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}
export default service;
